import React from 'react'
import PropTypes from 'prop-types';
import {Route, Switch} from 'react-router-dom';
import RouterPath from 'libs/RouterPath';
import PurchaserOfferPanel from "./offer/PurchaserOfferPanel";

const rp = RouterPath.purchaserDemand;

function PurchaserScenesRouter() {
    return (
        <Switch>
            <Route exact path={rp.PURCHASER_DEMAND_ID_OFFER_CONTRACTOR_ID} component={PurchaserOfferPanel}/>
            <Route exact path={rp.PURCHASER_DEMAND_ID_PREVIEW} component={PurchaserOfferPanel}/>
            <Route exact path={rp.PURCHASER_DEMAND_ID_OFFER_CONTRACTOR_ID_STAGE} component={PurchaserOfferPanel}/>
            <Route exact path={rp.PURCHASER_DEMAND_ID_OFFER_CONTRACTOR_ID_STAGE_ID} component={PurchaserOfferPanel}/>
            <Route exact path={rp.PURCHASER_DEMAND_ID_OFFER_CONTRACTOR_ID_STAGE_ID_SECTION} component={PurchaserOfferPanel}/>
        </Switch>
    )
}

PurchaserScenesRouter.propTypes = {
    classes: PropTypes.any,
}

PurchaserScenesRouter.defaultProps = {}

export default PurchaserScenesRouter;